import * as React from "react";
import { forwardRef } from "react";
const SvgArrowMenu = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 30, height: 23, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", fillOpacity: 0.1, d: "M0 5.008a5.8 5.8 0 0 1 .5-2.325c.34-.79.897-1.463 1.601-1.939A4.33 4.33 0 0 1 4.475 0h21.048c.844.01 1.668.268 2.373.744a4.47 4.47 0 0 1 1.601 1.939 5.47 5.47 0 0 1-.65 5.647L18.323 21.362a4.3 4.3 0 0 1-1.479 1.207 4.17 4.17 0 0 1-3.69 0 4.3 4.3 0 0 1-1.48-1.207L1.15 8.33A5.34 5.34 0 0 1 0 5.008" }));
const ForwardRef = forwardRef(SvgArrowMenu);
export { ForwardRef as ReactComponent };
